// Clean and normalize the Deal Version filter object for API requests
export function cleanDealVersionFilter(filter, rangeParam, sortParam) {
    const filtered = Object.fromEntries(
        Object.entries(filter)
            .map(([k, v]) => {
                // Convert boolean values to strings for URL params
                if (k === 'showSubversions') {
                    return [k, v ? 'true' : 'false'];
                }
                return [k, v];
            })
            .filter(([k, v]) => {
                // Always include boolean fields even when false
                if (k === 'showSubversions') {
                    return true;
                }
                return v != null && v !== '';
            }),
    );

    if (rangeParam) filtered.rangeParam = rangeParam;
    if (sortParam) filtered.sortParam = sortParam;

    return filtered;
}
